import type { FC } from 'react';
import React from 'react';
import { getCurrentTheme } from '../getCurrentTheme';
import { BrandLogo as DefaultBrandLogo } from '../../default/BrandLogo';
import type { BrandLogoProps } from './BrandLogoProps';

// Green build only — tree-shaken out of the default bundle via DefinePlugin.
const GreenBrandLogo =
  process.env.USE_GREEN === 'true' || process.env.NODE_ENV === 'test'
    ? (require('../../green/BrandLogo').default as FC<BrandLogoProps>)
    : DefaultBrandLogo;

export const BrandLogo = (props: BrandLogoProps) => {
  const Logo = getCurrentTheme() === 'green' ? GreenBrandLogo : DefaultBrandLogo;

  return <Logo {...props} />;
};
